<template>
  <div class="qa-enable-container">
    <svg-icon class="qa-enable-icon" icon-class="qa-enable" />
    <span class="qa-enable-text">启用问答后，请提示参会人提问</span>
    <span class="qa-enable-apply-tetx">参会人按“*1”申请提问</span>
    <a-button
      class="qa-enable-apply-button"
      @click="handleEnableQa"
      type="primary"
      >启动问答</a-button
    >
  </div>
</template>

<script>
import { startQa } from "@/services/qa";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["chairmanInParty", "presenterInParty"]),
    meetingIsStart() {
      return this.$store.getters.meetingIsStart;
    },
    meetingIsLock() {
      return this.$store.getters.meetingIsLock;
    }
  },
  methods: {
    handleEnableQa() {
      if (this.meetingIsStart) {
        if (this.chairmanInParty || this.presenterInParty) {
          if (this.meetingIsLock) {
            this.$message.error(`会议已锁定，不能启用问答。`);
          } else {
            startQa()
              .then(() => {})
              .catch(error => {
                console.log(error);
                this.$message.error(`启动问答请求失败。`);
              });
          }
        } else {
          this.$message.error(`主持人或主讲人还未入会，不能启用问答。`);
        }
      } else {
        this.$message.error(`会议未开启，不能启用问答。`);
      }
    }
  }
};
</script>

<style lang="less">
.qa-enable-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  .qa-enable-icon {
    width: 160px;
    height: 120px;
    margin-top: -240px;
    margin-bottom: 10px;
  }
  .qa-enable-text {
    font-size: 20px;
    color: #417ff9;
    margin-bottom: 8px;
  }
  .qa-enable-apply-tetx {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
    margin-bottom: 24px;
  }
  .qa-enable-apply-button {
    width: 192px;
  }
}
</style>
